// https://developers.facebook.com/docs/facebook-pixel/implementation/pixel-for-official-events#object-properties
import config from "../../config";
const errorTracking = require("../../utils/ErrorTracking");

const FacebookPixelService = {
  track(type, fbEventName, fbEventData, event) {
    fbEventData.content_ids =
      event && event.dates ? event.dates.map(d => d._id) : [];
    fbEventData.eventref = window.fb_oea ? "fb_oea" : "";
    if (window.fbq) {
      fbq(type, fbEventName, fbEventData);
    }
  },
  ticketsViewed(event) {
    this.track("trackCustom", "ViewContent", {}, event);
  },
  ticketsAdded(event, order) {
    try {
      if (event && order) {
        this.track(
          "trackCustom",
          "TicketsAdded",
          {
            currency: config("CURRENCY"),
            totalTickets: order.tickets.length
          },
          event
        );
      }
    } catch (e) {
      errorTracking.track(e);
    }
  },
  enteredDetails(event, order) {
    try {
      if (event && order) {
        this.track(
          "trackCustom",
          "EnteredDetails",
          {
            value: order.totals.total,
            currency: config("CURRENCY"),
            totalTickets: order.tickets.length
          },
          event
        );
      }
    } catch (e) {
      errorTracking.track(e);
    }
  },
  checkout(event, order) {
    if (event && order) {
      this.track(
        "track",
        "InitiateCheckout",
        {
          value: order.totals.total,
          currency: config("CURRENCY"),
          totalTickets: order.tickets.length
        },
        event
      );
    }
  },
  complete(event, order) {
    try {
      if (event && order) {
        this.track(
          "track",
          "Purchase",
          {
            value: order.totals.total,
            currency: config("CURRENCY"),
            totalTickets: order.tickets.length,
            num_items: order.tickets.length
          },
          event
        );
      }
    } catch (e) {
      errorTracking.track(e);
    }
  }
};
export default FacebookPixelService;



// WEBPACK FOOTER //
// ./services/tracking/FacebookPixelService.js